import React from 'react';
import { Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { styles } from '../../styles/cards/checkListStyles';
import {GreenCheckIcon, RedXIcon} from '../../customIcons';

const CheckList = ({fields, checkListValues}) => {

    const theme = useTheme();
    const style = styles(theme);
    return (
        <Container>
            {fields.map((field, index) => {
                return (
                    <Container sx={style.itemContainer} key={index}>
                        {checkListValues[field.field] === true
                            ? <GreenCheckIcon sx={style.icon}/> 
                            : <RedXIcon sx={style.icon}/>
                        }
                        <Typography style={style.itemText}>{field.title}</Typography>
                    </Container>
                );
            })}
        </Container>
    );
};

export default CheckList;